<div class="custom-alert-container">
    <div class="gif-box">
        <img [src]="gifPath" alt="gif-img">
    </div>
    <div class="content-box" id="content-alert-box">
        <!-- <div (click)="closeAlert()" class="close-btn">x</div> -->
        <div class="close-btn" (click)="closeAlert()"><mat-icon>close</mat-icon></div>
        <div class="title">{{title}}</div>
        <!-- <div class="sub-title">{{subTitle}}</div> -->
        <div class="sub-title" [innerHTML]="subTitle"></div>
    </div>
</div>